import { FormGroup } from '@angular/forms';
import { ActionDI, TicketCtx } from './ticket-actions.service';
import { TicketActionModalComponent } from '../../containers/ticket-action-modal/ticket-action-modal.component';
import { TicketActivateConfirmationComponent } from '@ridango/components/lib/tickets/components/ticket-activate-confirmation/ticket-activate-confirmation.component';

export async function openTicketActionModal(action: string, form: FormGroup, ctx: TicketCtx, di: ActionDI) {
    const modal = await di.modal.create({
        component: TicketActionModalComponent,
        cssClass: action === 'LEND_TICKET' ? 'ticket-lend-action-modal' : 'ticket-action-modal',
        componentProps: {
            action,
            refreshTickets: ctx.refresh,
            locale: ctx.locale,
            form,
            docNum: ctx.env.IS_NEW_AFC ? ctx.ticket.id : ctx.ticket.docNum,
            ticket: ctx.ticket
        }
    });

    await modal.present();
}

export async function activateManually(ctx: TicketCtx, di: ActionDI, callback?: () => void) {
    const modal = await di.modal.create({
        component: TicketActivateConfirmationComponent,
        cssClass: 'ticket-activate-confirmation-modal',
        componentProps: { data: { docNum: ctx.env.IS_NEW_AFC ? ctx.ticket.id : ctx.ticket.docNum }, callback }
    });

    await modal.present();

    //TODO: check if needed after https://int.jira.ridango.com/browse/STW-897
    const title = modal.querySelector<HTMLElement>('[data-modal-title]');
    if (title) {
        title.focus();
    }

    const { data } = await modal.onWillDismiss<boolean>();
    if (callback && data) {
        callback();
    }
}
